/**
 * Export lib/mongoose
 *
 */

'use strict';

module.exports = require('./lib/browser');



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/browser.js
// module id = 328
// module chunks = 0